import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  countryCode: [],
};

const commonSlice = createSlice({
  name: 'commonSlice',
  initialState,
  reducers: {
    setCountryCode(state: any, action: any) {
      console.log('🚀 ~ setCountryCode ~ action:', action);
      state.countryCode = action.payload;
    },
  },
});

export const {setCountryCode} = commonSlice.actions;

export default commonSlice.reducer;
